/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import FormField from '../../../../client/js/components/form/fields/FormField'
import { FUNDING_CASH, FUNDING_LOAN } from '../../enums/FundingMethodCodes.mjs'
import { Select, SelectProps } from '@mantine/core'

export type FundingMethodFieldProps = Omit<SelectProps, 'data'>

function FundingMethodField (props: FundingMethodFieldProps) {
  const { name = 'fundingMethod', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      label={intl.formatMessage({
        id: 'funding_method',
        defaultMessage: 'Mode de financement'
      })}
      {...others}
      name={name}
      render={Select}
      data={[
        {
          label: intl.formatMessage({
            id: 'undefined',
            defaultMessage: 'Non défini'
          }),
          value: ''
        },
        {
          label: intl.formatMessage({
            id: 'cash',
            defaultMessage: 'Comptant'
          }),
          value: FUNDING_CASH
        },
        {
          label: intl.formatMessage({
            id: 'loan',
            defaultMessage: 'Prêt bancaire'
          }),
          value: FUNDING_LOAN
        }
      ]}
    />
  )
}

export default FundingMethodField
